// Generated using typescript-generator version 1.28.343 on 2017-09-16 19:05:59.

export interface NoteId {
    noteId: string;
}

export interface UpdatedNote {
    content: string;
}

export interface Note {
    id: string;
    content: string;
    created: Date;
    modified: Date;
}

export interface RestApplication {

    /**
     * HTTP POST /notes
     * Java method: api.NotesService.createNote
     */
    createNote(): RestResponse<NoteId>;

    /**
     * HTTP DELETE /notes/{noteId}
     * Java method: api.NotesService.deleteNote
     */
    deleteNote(noteId: string): RestResponse<void>;

    /**
     * HTTP GET /notes
     * Java method: api.NotesService.getNotes
     */
    getNotes(): RestResponse<Note[]>;

    /**
     * HTTP PUT /notes/{noteId}
     * Java method: api.NotesService.updateNote
     */
    updateNote(noteId: string, arg2: UpdatedNote): RestResponse<void>;
}

export interface HttpClient {

    request(requestConfig: { method: string; url: string; queryParams?: any; data?: any; }): RestResponse<any>;
}

export class RestApplicationClient implements RestApplication {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP POST /notes
     * Java method: api.NotesService.createNote
     */
    createNote(): RestResponse<NoteId> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`notes` });
    }

    /**
     * HTTP DELETE /notes/{noteId}
     * Java method: api.NotesService.deleteNote
     */
    deleteNote(noteId: string): RestResponse<void> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`notes/${noteId}` });
    }

    /**
     * HTTP GET /notes
     * Java method: api.NotesService.getNotes
     */
    getNotes(): RestResponse<Note[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`notes` });
    }

    /**
     * HTTP PUT /notes/{noteId}
     * Java method: api.NotesService.updateNote
     */
    updateNote(noteId: string, arg2: UpdatedNote): RestResponse<void> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`notes/${noteId}`, data: arg2 });
    }
}

export type RestResponse<R> = Promise<R>;

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
    let result = "";
    for (let i = 0; i < substitutions.length; i++) {
        result += template[i];
        result += encodeURIComponent(substitutions[i]);
    }
    result += template[template.length - 1];
    return result;
}



// WEBPACK FOOTER //
// ./src/_generated/service.ts